export default "__VITE_ASSET__bYsOpjOL__"